module.exports = __webpack_public_path__ + "static/media/eye-closed.e46ad31a.svg";